<template>
  <header class="head-panel">
    <router-link
      v-if="hasViewWelcome"
      class="head-panel__logo-link"
      v-bind:to="{ name: 'ClinicPanelWelcome' }"
    >
      <img
        alt="Логотип"
        class="head-panel__logo"
        src="@/assets/img/logo/logo.png" />
    </router-link>
    <img
      v-else
      alt="Логотип"
      class="head-panel__logo"
      src="@/assets/img/logo/logo.png" />
    <router-link
      class="head-panel__logo-link mob"
      v-bind:to="{ name: 'ClinicPanelAppointmentScheduleEmployees' }"
    >
      <img
        alt="Логотип"
        class="head-panel__logo mob"
        src="@/assets/img/logo/logo-white.png" />
    </router-link>
    <button
      type="button"
      class="head-panel__drawer"
      v-bind:class="{ active: drawer }"
      v-on:click="drawer = !drawer">
      <div class="head-panel__body">
        <slot name="body" />
      </div>
      <div class="head-panel__aside">
        <div v-if="isProfileLoaded" class="head-panel__aside__left">
          <div v-if="restrictedAccessClinic" class="head-panel__aside__info-tarif">
            Ваш тариф истек. Для полноценной работы продлите
            <router-link
              v-bind:to="{ name: 'ClinicPanelTariffs' }"
            >
              тариф
            </router-link>
          </div>
          <div v-else-if="tariffExpiringNotification">
            {{ tariffExpiringNotification }}.
            <router-link v-bind:to="{ name: 'ClinicPanelTariffs', query: { tariff: true } }">
              Перейти к оплате
            </router-link>
          </div>
          <div class="head-panel__aside__row">
            <button
              v-if="whatsAppAccess"
              class="head-panel__icon whatsapp"
              type="button"
              v-on:click="onShowWhatsAppChat"
              title="Чат в WhatsApp"
            >
              <div
                class="head-panel__notifications__new"
                v-if="newWhatsAppNotificationCount > 0"
              />
            </button>
            <button
              v-if="messengersAccess"
              class="head-panel__button-chat"
              type="button"
              v-on:click="onShowMessengersChats"
              title="Веб-Мессенджер"
            />
            <div v-if="callListAccess" class="head-panel__tooltip">
              <button
                class="head-panel__icon phone head-panel__tooltip__activator"
                type="button"
                v-on:click="onShowActiveCalls"
                v-on:focus="onHoverCalls"
                v-on:mouseenter="onHoverCalls"
              />
              <span
                v-if="hasCallHoverMessage"
                class="head-panel__tooltip__text"
              >{{callHoverMessage}}</span>
            </div>
            <template>
              <div v-if="!isMobile" class="head-panel__user">
                <v-menu
                  v-on:input="onOpenProfileMenu"
                  open-on-click
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="head-panel__user__avatar" v-bind="attrs" v-on="on">
                      <img
                        v-if="userPhotoUrl"
                        :src="userPhotoUrl"
                        alt="фото"
                      >
                      <div v-else class="head-panel__user__avatar__default">{{ userInitials }}</div>
                    </div>
                    <v-card-title
                      class="head-panel__user__text"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ userSurnameWithInitials }}
                    </v-card-title>
                  </template>
                  <v-list
                    class="head-panel__user__options"
                  >
                    <v-list-item>
                      <router-link
                        :to="{ name: 'ClinicPanelUserProfile' }"
                      >
                        Мой профиль
                      </router-link>
                    </v-list-item>
                    <v-list-item>
                      <button
                        class="head-panel__exit"
                        type="button"
                        v-on:click="logout"
                      >
                        Выход
                      </button>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </template>
          </div>
        </div>
        <slot name="aside" />
      </div>
    </button>
    <div class="head-panel__container">
      <div class="head-panel__updates-button">
        <slot name="updates-button" />
      </div>
      <button
        class="head-panel__btn"
        type="button"
        v-bind:class="{ active: drawer }"
        v-on:click="drawer = !drawer">
        <span />
      </button>
    </div>
  </header>
</template>
<script>
import mobileMixin from '@/mixins/mobileMixin';
import { GOAL_CLICK_MY_PROFILE } from '@/plugins/metric';

/**
 * @description Название события просмотра активных звонков.
 * @type {string}
 */
const NAME_EVENT_SHOW_ACTIVE_CALLS = 'show-active-calls';

/**
 * @description Название события просмотра активных звонков.
 * @type {string}
 */
const NAME_EVENT_HOVER_CALLS = 'hover-calls';

/**
 * @description Название события просмотра чата Whats App
 * @type {string}
 */
const NAME_EVENT_SHOW_WHATS_APP_CHAT = 'show-whats-app-chat';

/**
 * @description Название события открытия диалогового окна чатов Мессенджеров.
 * @type {string}
 */
const NAME_EVENT_SHOW_MESSENGERS_CHATS_DIALOG = 'show-messengers-chats-dialog';

export default {
  components: {},
  computed: {
    hasCallHoverMessage() {
      return !!this.callHoverMessage;
    },
    newNotificationCount() {
      return this.$store.getters.getNewNotificationCount;
    },
    newWhatsAppNotificationCount() {
      return this.$store.getters.getNewWhatsAppNotificationCount;
    },
    userPhotoUrl() {
      return this.$store.getters.getProfile.photo_url;
    },
    userSurnameWithInitials() {
      return this.$store.getters.getProfile.surname_with_initials;
    },
    userInitials() {
      return this.$store.getters.getProfile.initials;
    },
    restrictedAccessClinic() {
      return this.$store.getters.getProfile.restricted_access_clinic;
    },
    tariffExpiringNotification() {
      return this.$store.getters.getProfile.tariff_expiring_notification;
    },
    hasViewWelcome() {
      return this.$store.getters.isSectionAvailable('welcome');
    },
  },
  data() {
    return {
      drawer: false,
    };
  },
  methods: {
    /**
     * @description Обработать событие клика по профилю
     * @returns {void}
     */
    onOpenProfileMenu() {
      this.reachGoal();
    },
    /**
     * @description Достичь цели
     * @returns {void}
     */
    reachGoal() {
      this.$goal(GOAL_CLICK_MY_PROFILE);
    },
    onHoverCalls() {
      this.$emit(NAME_EVENT_HOVER_CALLS);
    },
    /**
     * @description Обработать просмотр активных звонков.
     * @returns {void}
     */
    onShowActiveCalls() {
      this.$emit(NAME_EVENT_SHOW_ACTIVE_CALLS);
    },
    /**
     * @description Обработать просмотр чата Whats App
     * @return {void}
     */
    onShowWhatsAppChat() {
      this.$emit(NAME_EVENT_SHOW_WHATS_APP_CHAT);
    },
    /**
     * @description Обработать просмотр диалогового окна чатов мессенджеров.
     * @return {void}
     */
    onShowMessengersChats() {
      this.$emit(NAME_EVENT_SHOW_MESSENGERS_CHATS_DIALOG);
    },
    /**
     * @description Отправить событие выхода
     */
    logout() {
      this.$emit('logout');
    },
  },
  name: 'HeadPanel',
  props: {
    callListAccess: { default: () => false, type: Boolean },
    callHoverMessage: { required: true, type: String },
    isProfileLoaded: { required: true, type: Boolean },
    whatsAppAccess: { default: () => false, type: Boolean },
    messengersAccess: { default: () => false, type: Boolean },
  },
  mixins: [
    mobileMixin,
  ],
};
</script>
<style lang="scss">
.head-panel {
  display: grid;
  grid-template-columns: 125px 1fr;
  align-items: center;
  column-gap: 10px;
  padding: 10px 26px;
  background-color: #ffffff;
  border: 1px solid rgba(194, 207, 224, 0.5);
  z-index: 5;
  &__body {
    display: flex;
    align-items: center;
    column-gap: 20px;
    &__select-clinics {
      width: 100%;
      max-width: 240px;
      .v-text-field {
        margin: 0;
        padding: 0;
      }
    }
    // &__updates {
    //   margin-left: auto;
    // }
  }
  &__logo-link {
    &.mob {
      display: none;
    }
  }
  &__logo {
    height: 38px;
    width: 125px;
    &.mob {
      display: none;
    }
  }
  &__tooltip {
    position: relative;
    &__text {
      display: none;
      position: absolute;
      font-size: 14px;
      background-color: rgba(97,97,97,.9);
      border-radius: 4px;
      color: white;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 10px;
      pointer-events: none;
      white-space: nowrap;
      padding: 5px 16px;
    }
    &__activator:hover ~ &__text{
      display: block;
    }
  }
  &__drawer {
    text-align: left;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    column-gap: 20px;
    cursor: default;
  }
  &__updates-button,
  &__notification-icon-tel {
    display: none;
  }
  &__link {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: var(--reading-color) !important;
    margin: 0 35px 0 0;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
    &.router-link-exact-active {
      color: #0489e0 !important;
    }
  }
  &__notifications {
    &__new {
      position: absolute;
      bottom: 0px;
      right: 0px;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background: #f3554c;
    }
  }
  &__button-chat {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: no-repeat url('@/assets/img/chat.svg') 50%;
    background-size: contain;
    border: 1px solid transparent;
    border-radius: 15px;
    transition: 0.3s;
  }
  &__aside {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    &__left {
      gap: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    &__row{
      gap: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    &__info-tarif {
      max-height: 72px;
      overflow-y: auto;
      a:hover {
        text-decoration: none;
      }
    }
  }
  &__icon {
    display: flex;
    flex-shrink: 0;
    height: 23px;
    position: relative;
    background-size: contain;
    background-position: center;
    &.task {
      width: 23px;
      background-image: url('@/assets/img/task.svg');
      &:hover {
        background-image: url('@/assets/img/task-blue.svg');
      }
    }
    &.help {
      width: 23px;
      background-image: url('@/assets/img/help-grey.svg');
      overflow: hidden;
      &:hover {
        background-image: url('@/assets/img/help-blue.svg');
      }
    }
    &.phone {
      width: 23px;
      background-image: url('@/assets/img/phone-grey.svg');
      &:hover {
        background-image: url('@/assets/img/phone-blue.svg');
      }
    }
    &.whatsapp {
      width: 23px;
      background-image: url('@/assets/img/social/whatsapp-brand-green.svg');
      &:hover {
        filter: brightness(95%) contrast(85%);
      }
    }
  }
  &__email {
    position: relative;
    display: flex;
    &:before {
      content: "";
      background-image: url("@/assets/img/email-grey.svg");
      background-repeat: no-repeat;
      background-size: contain;
      width: 26px;
      height: 23px;
      margin: 0 0 0 30px;
    }
    &:hover::before {
      background-image: url("@/assets/img/email-blue.svg");
    }
    &__new {
      position: absolute;
      bottom: 0px;
      right: 0px;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background: #f3554c;
    }
  }
  &__user {
    display: flex;
    flex-direction: row;
    align-items: center;
    &__avatar {
      img,
      &__default {
        object-fit: cover;
        object-position: center;
        border-radius: 50%;
        width: 34px;
        min-width: 34px;
        height: 34px;
        min-height: 34px;
        margin: 0 10px 0 0;
      }
      &__default {
        background-color: var(--action-color);
        color: white;
        font-weight: bold;
        line-height: 34px;
        text-align: center;
      }
    }
    &__options {
      color: #192A3E;
      a {
        color: #192A3E !important;
        text-decoration: none;
        &:hover {
          color: #0489e0 !important;
        }
      }
      button:hover {
        color: #0489e0;
      }
    }
    &__text {
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      color: #90a0b7 !important;
      text-decoration: none;
      padding: 0;
      &:hover {
        text-decoration: underline;
      }
      &.v-card__title {
        margin: 0;
        word-break: normal;
      }
    }
  }
  &__exit {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #90a0b7;
    &:before {
      content: "";
      background-image: url("@/assets/img/out-grey.svg");
      background-repeat: no-repeat;
      background-size: contain;
      margin: 0 5px 0 0;
      width: 18px;
      height: 17px;
    }
    &:hover::before {
      background-image: url("@/assets/img/out-blue.svg");
    }
  }
  &__btn {
    display: none;
  }
}

@media screen and (max-width: 960px) {
  .head-panel {
    background-color: #323C47 !important;
    &__body {
      &__updates {
        display: none;
      }
      &__select-clinics {
        max-width: none;
      }
    }
    &__notification-icon-desktop {
      display: none;
    }
    &__updates-button {
      position: absolute;
      right: 90px;
      display: block;
    }
    &__notification-icon-tel {
      position: absolute;
      right: 50px;
      display: block;
    }
    &__logo-link {
      display: none;
      &.mob {
        display: block;
      }
    }
    &__logo {
      display: none;
      &.mob {
        display: flex;
      }
    }
    &__container {
      position: relative;
      display: flex;
      align-items: center;
    }
    &__btn {
      display: flex;
      align-items: center;
      position: absolute;
      right: 0;
      width: 26px;
      height: 26px;
      cursor: pointer;
      z-index: 1;
    }
    &__btn > span,
    &__btn > span::before,
    &__btn > span::after {
      display: block;
      position: absolute;
      width: 100%;
      height: 2px;
      background-color: #EAEFF3;
      transition: all 0.15s linear;
    }
    &__btn > span::before {
      content: "";
      top: -8px;
    }
    &__btn > span::after {
      content: "";
      top: 8px;
    }
    &__btn.active > span {
      transform: rotate(45deg);
    }
    &__btn.active > span::before {
      top: 0;
      transform: rotate(0);
    }
    &__btn.active > span::after {
      top: 0;
      transform: rotate(90deg);
    }
    &__drawer {
      display: none;
      &.active {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        row-gap: 5px;
        padding: 50px 20px 60px;
        position: absolute;
        right: 0;
        top: 0;
        background: #323C47;
        box-shadow: -6px 0px 18px rgba(0, 0, 0, 0.06);
        height: 100vh;
        overflow-x: hidden;
        overflow-y: scroll;
        width: 100%;
        max-width: 400px;
        z-index: 1;
      }
      .head-panel__body {
        flex-direction: column-reverse;
        display: flex;
        align-items: flex-start;
        align-self: flex-start;
        gap: 30px;
        width: 100%;
      }
    }
    &__notification-icon-desktop {
      display: none;
    }
    &__link {
      margin: 0 0 35px 0;
    }
    &__aside {
      flex-direction: column;
      margin: 15px 0 30px 0;
      &__left {
        flex-direction: column;
      }
      &__row {
        width: 100%;
      }
      &__info-tarif {
        font-size: 16px;
        line-height: 19px;
        color: #EAEFF3 !important;
        a {
          color: #EAEFF3 !important;
        }
      }
    }
    &__exit {
      color: #EAEFF3 !important;
      font-weight: 400;
      &:before {
        background-image: url("@/assets/img/out-white.svg");
        margin: 0 10px 0 0;
        width: 20px;
        height: 20px;
      }
    }
    &__icon {
      &.task {
        background-image: url('@/assets/img/nav/task.svg');
      }
      &.help {
        background-image: url('@/assets/img/nav/help.svg');
      }
      &.phone {
        background-image: url('@/assets/img/phone-white.svg');
        width: 20px;
        height: 20px;
      }
    }
    &__user {
      display: none;
      margin: 0;
      &__text {
        color: #EAEFF3 !important;
      }
      &__options {
        display: none;
      }
    }
  }
}
</style>
